// client/requestHandler.ts
import { from } from "rxjs";
import { switchMap } from "rxjs/operators";
import { generateOperationString } from "../utils/queryGeneration.js";
import { BaseQLClient } from "./baseqlClient.js";
import { baseqlMetaData } from "../metadata/metaDataStore.js";
function handleClientRequest(opType, op) {
  return function(...params) {
    const operations = opType === "query" ? baseqlMetaData.queries : opType === "mutation" ? baseqlMetaData.mutations : baseqlMetaData.subscriptions;
    const realOp = operations[op.name];
    if (!realOp)
      throw new Error(`Could not find ${opType} with name ${op.name}`);
    const variables = Object.fromEntries(realOp.params.map((param, index) => [param.name, params[index]]));
    const metadata = { calledOn: this?._class ?? "standalone", calledOnInstance: this };
    return (gqlFields) => {
      switch (opType) {
        case "subscription":
          return from(BaseQLClient.getRequestHandler()).pipe(
            switchMap((handler) => {
              return handler.subscription(realOp, {
                variables,
                metadata,
                // Pass variables too so we avoid unnecessary vars in query string
                subscription: generateOperationString("subscription", realOp, gqlFields)
              });
            })
          );
        case "query":
          return BaseQLClient.getRequestHandler().then((handler) => {
            return handler.query(realOp, {
              variables,
              metadata,
              query: generateOperationString("query", realOp, gqlFields)
            });
          });
        case "mutation":
          return BaseQLClient.getRequestHandler().then((handler) => {
            return handler.mutation(realOp, {
              variables,
              metadata,
              mutation: generateOperationString("mutation", realOp, gqlFields)
            });
          });
        default:
          throw new Error("unsupported opType");
      }
    };
  };
}
export {
  handleClientRequest
};
